<template>
  <div
    id="autocomplete"
    class="autocomplete"
  >
    <input
      v-model="text"
      class="autocomplete-input"
      :class="{'autocomplete-input_expanded': isOpen}"
      placeholder="Поиск"
      @input="onInput"
    >

    <ul
      v-if="isOpen"
      class="autocomplete-result-list"
    >
      <li
        v-for="{ value, text} of items"
        :key="value"
        v-text="text"
        class="autocomplete-result-list__item"
        @click="onSelect(value)"
      />
    </ul>
  </div>
</template>

<script>
import { debounce } from '@/utils/functions'

export default {
  name: 'AutoComplete',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      text: '',
      selectedId: null,
      isOpen: false
    }
  },
  emits: ['search', 'select'],
  watch: {
    items: 'onOpen'
  },
  methods: {
    onInput: debounce(function () {
      this.selectedId = null
      this.$emit('search', this.text)
    }, 500),
    onSelect (selectedId) {
      const text = this.items.find(item => item.value === selectedId)?.text
      this.selectedId = selectedId
      this.text = text

      this.$emit('select', selectedId)
      this.OnClose()
    },
    onOpen () {
      this.isOpen = true
    },
    OnClose () {
      this.isOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
.autocomplete {
  position: relative;

  &-input {
    display: block;
    padding: 0 16px;
    width: 100%;
    height: 42px;
    background-color: #242428;
    border-radius: 10px;
    border: none;
    appearance: none;
    outline: none;
    font-weight: 400;
    font-size: 18px;
    color: #A1A1A8;
    line-height: 1.5;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M7.33329 14.0001C8.81244 13.9998 10.249 13.5046 11.4141 12.5934L15.0775 16.2567L16.2558 15.0784L12.5925 11.4151C13.5041 10.2498 13.9996 8.81295 14 7.33341C14 3.65758 11.0091 0.666748 7.33329 0.666748C3.65746 0.666748 0.666626 3.65758 0.666626 7.33341C0.666626 11.0092 3.65746 14.0001 7.33329 14.0001ZM7.33329 2.33341C10.0908 2.33341 12.3333 4.57591 12.3333 7.33341C12.3333 10.0909 10.0908 12.3334 7.33329 12.3334C4.57579 12.3334 2.33329 10.0909 2.33329 7.33341C2.33329 4.57591 4.57579 2.33341 7.33329 2.33341Z' fill='%23A1A1A8'/%3e%3c/svg%3e ");
    background-repeat: no-repeat;
    background-position-x: 16px;
    background-position-y: center;
    background-size: 18px;
    padding-left: 40px;

    &_expanded {
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }

  &-result-list {
    position: absolute;
    bottom: 0;
    transform: translateY(100%);
    width: 100%;
    max-height: 250px;
    overflow: auto;
    background: #fff;
    z-index: 1;

    &__item {
      padding: 12px 8px;
      cursor: pointer;
      color: #000;

      &_selected,
      &:hover {
        background: #F2F5F9;
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>
